import { useState, useReducer, useEffect } from "react"
import { IContext } from "interfaces/IContext"
import { GlobalContext } from "context/context/GlobalContext"
import { NotificationReducer } from "context/reducers/NotificationReducer"
import { IErrorHandler } from "interfaces/IErrorHandler"

/**
 * GlobalProvider this is the global context of services
 * @param {children} type IContext
 * @return {Element} of type GlobalContext.Provider
 */
const GlobalProvider = ({ children }: IContext) => {
  const [showUserProfileHeader, setShowUserProfileHeader] = useState(false)
  const [notifcations, setNotifications] = useReducer(NotificationReducer, [])
  const [error, setError] = useState<IErrorHandler>({ hasError: false })
  const [displayRouteName, setDisplayRouteName] = useState("")
  const [boxSearch, setBoxSearch] = useState({ option: "", value: "" })
  const [state_machine_states, set_state_machine_status] = useState([])
  const [showAlertSessionError, setShowAlertSessionError] = useState(false)
  const [schedules, set_schedules] = useState([])

  useEffect(() => {
    const local_state_machine = localStorage.getItem("STATE_MACHINE")
    if (!local_state_machine) {
      localStorage.removeItem("STATE_MACHINE")
      return
    }

    set_state_machine_status(JSON.parse(local_state_machine) || [])
  }, [])

  useEffect(() => {
    const alertSessionError = localStorage.getItem("ALERT_SESSION_ERROR")
    if (!alertSessionError) {
      localStorage.removeItem("ALERT_SESSION_ERROR")
      return
    }

    setShowAlertSessionError(JSON.parse(alertSessionError) || false)
  }, [showAlertSessionError])

  useEffect(() => {
    const local_schedules = localStorage.getItem("SCHEDULES")
    if (!local_schedules) {
      localStorage.removeItem("SCHEDULES")
      return
    }

    set_schedules(JSON.parse(local_schedules) || [])
  }, [])

  const dataProvider = {
    // It is to know if it is in the path of the user information in the header
    userProfileHeader: {
      state: showUserProfileHeader,
      dispatch: setShowUserProfileHeader,
    },
    // this is Notifications for the user
    notification: {
      state: notifcations,
      dispatch: setNotifications,
    },
    //this is to handle global bugs
    errorHander: {
      state: error,
      dispatch: setError,
    },
    displayHeaderRouteName: {
      state: displayRouteName,
      dispatch: (payload: string) => setDisplayRouteName(payload),
    },
    userSearch: {
      state: boxSearch,
      dispatch: setBoxSearch,
    },
    state_machine_states: {
      state: state_machine_states,
      dispatch: set_state_machine_status,
    },
    showAlertSessionError: {
      state: showAlertSessionError,
      dispatch: setShowAlertSessionError,
    },
    schedules: {
      state: schedules,
      dispatch: set_schedules,
    },
  }

  return <GlobalContext.Provider value={dataProvider}>{children}</GlobalContext.Provider>
}

export default GlobalProvider
